import { ref, onBeforeUnmount } from 'vue';
import {itExist} from "@/utils/general-utils";

export enum CareTipType {
    CUSTOM = 'CUSTOM',
    GENERIC = 'GENERIC'
}

export interface CareTip {
    type: CareTipType;
    title: string;
    content: string;
}

export enum ProductCategory {
    HDB = 'HDB',
    RTW = 'RTW'
}

export interface Product {
    serialNumber: string;
    color: string;
    fabric: string;
    name: string;
    reference: string;
    retailDate: string;
    retailLocationName: string;
    warrantyEndDate: string;
    photoUrl: string;
    warrantyEligible: boolean;
    warrantyActive: boolean;
    warrantyDurationLabel: string | null;
    warrantyDurationValue: string | null;
    seasonCode: string | null;
    seasonLabel: string | null;
    careTips: CareTip[];
    category: string;
    size: string;
}

export const isHdbProduct = (product: Product) => product.category === ProductCategory.HDB;
export const isRtwProduct = (product: Product) => product.category === ProductCategory.RTW;

export const isDesktop = ref(false);

export function resizeEvent(): void {
    isDesktop.value = window.matchMedia("screen and (min-width: 601px)").matches;
}

window.addEventListener('resize', resizeEvent, {passive: true});
onBeforeUnmount(() => {
    window.removeEventListener('resize', resizeEvent);
});

export function productThumbnail(url: string, width: number|null, height: number|null): string {
    const imgWidth = width || 'auto';
    const imgHeight = height || 'auto';

    const regex = new RegExp('(https:\\/\\/www.chanel.com\\/images\\/)(.*)(\\/.+)', 'gi');
    const transformations = 't_fashionselector/t_fashioncenteredwhitebackground/c_pad,c_fill,q_auto,f_auto,fl_lossy,dpr_3,w_' + imgWidth + ',h_' + imgHeight;
    const replacement = '$1' + transformations + '$3';

    return url.replace(regex, replacement);
}

export function formatDate(date?: string | null, expectedLocale?: string|null): string {
    if (!itExist(date) || !itExist(expectedLocale)) {
        return "";
    }

    const dateOnly = `${date.substring(0, 10)}T00:00:00`; // Keep only the date and force time to midnight due to wrong retrieved timezone (temporary fix @see IT01FSHDPP-902)
    const locale = expectedLocale.replace('_', '-');
    const dateObject = new Date(dateOnly);

    if (isNaN(dateObject.getDate())) {
        console.error('Invalid Date', date, dateOnly, dateObject);
        return "";
    }

    return dateObject.toLocaleDateString(locale);
}
